import {
  ICreatePromoProgramParams,
  IPromoDetail,
  IPromoDetailRepository,
} from "@/core/repositories/promotion/IPromoDetail.repository";

export class CreatePromoProgramUseCase {
  constructor(private readonly repo: IPromoDetailRepository) {}

  async execute(params: ICreatePromoProgramParams): Promise<IPromoDetail> {
    return this.repo.createPromoProgram(params);
  }
}
